@for (file of files$ | async | keyvalue; track $index) {
  <p [attr.data-cy]="`file-download-item-${$index}`">
    {{ file.value.data?.name }}
    <app-file-progress [progress]="file.value.progress$ | async" />
  </p>
}
